import SmartTrackingPromoCard from './SmartTrackingPromoCard/SmartTrackingPromoCard'
import SmartTrackingRequestedCard from './SmartTrackingRequestedCard/SmartTrackingRequestedCard'

const SmartTrackingUpsell = ({ requested, requesting, onRequest }) => {
  if (requested) return <SmartTrackingRequestedCard />

  return <SmartTrackingPromoCard requesting={requesting} onRequest={onRequest} />
}

export default SmartTrackingUpsell
